import React from 'react'
import {
  Form,
  Button,
} from 'components/atoms'
import { Formik, Field } from 'formik';
import { FieldCustom } from 'components/molecules';
import PropTypes from 'prop-types'
import * as Yup from 'yup';
import styled from 'styled-components/macro';
import { linkRegex } from 'services/constants';

const LinkSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, 'Mínimo de 4 caracteres')
    .max(50, 'Máximo de 50 caracteres')
    .required('Campo obrigatório'),
  url: Yup.string()
    .matches(linkRegex, 'O URL inserido não é válido. Certifique-se que começa com http:// ou https:// para sites fora do portal ou com /{lingua}/... para ligações internas.')
    .required('Campo obrigatório')
});


const SideNavEditorLinkForm = ({
  initialValues, onChange, onSubmit, onDiscard
}) => {
  // when the values change Formik runs validate so we can values changing side effects here
  // update the page json by invoking onChange(newProps)
  const handleFormChange = (newValues) => {
    onChange(newValues)
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={LinkSchema}
      validate={handleFormChange}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
      enableReinitialize
    >
      <Form>
        <Field
          title="Link"
          name="url"
          info="Url do link do item de menu."
          component={FieldCustom}
        />
        <Field
          title="Título"
          name="title"
          info="Título do item de menu."
          component={FieldCustom}
          maxLetters={50}
        />
        <Actions>
          {typeof onDiscard === 'function' && (
            <Button type="button" modifiers={['marginRight', 'capitalize']} onClick={onDiscard}>
              Cancelar
            </Button>
          )}
          <Button
            type="submit"
            modifiers={['primary', 'capitalize']}
          >
              Adicionar
          </Button>
        </Actions>
      </Form>
    </Formik>
  )
}

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.l};
`;

SideNavEditorLinkForm.defaultProps = {
  initialValues: {
    title: '',
    url: ''
  },
  onSubmit: () => {},
  onDiscard: null,
  onChange: () => {}
}

SideNavEditorLinkForm.propTypes = {
  initialValues: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  onChange: PropTypes.func,
  onDiscard: PropTypes.func,
  onSubmit: PropTypes.func,
}


export default SideNavEditorLinkForm
